import { Button } from "@/components/ui/button";
import { Lock, UserCheck, UserPlus } from "lucide-react";
import { useTranslation } from "react-i18next";

interface PrivateProfileViewProps {
  profile: {
    username: string;
    privacy_setting: string;
  };
  isFollowing: boolean;
  userId: string | undefined;
  profileId: string;
  onFollowAction: () => void;
  followMutationPending: boolean;
  unfollowMutationPending: boolean;
}

const PrivateProfileView = ({
  profile,
  isFollowing,
  userId,
  profileId,
  onFollowAction,
  followMutationPending,
  unfollowMutationPending
}: PrivateProfileViewProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-8 text-center py-8 border rounded-lg">
      <Lock className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
      <h2 className="text-xl font-semibold mb-2">
        {t('profile.privateProfile')}
      </h2>
      <p className="text-muted-foreground mb-4">
        {profile.privacy_setting === 'private'
          ? t('profile.followToRequest')
          : t('profile.followToSee')}
      </p>
      {userId !== profileId && (
        <Button
          onClick={onFollowAction}
          disabled={followMutationPending || unfollowMutationPending}
          variant={isFollowing ? "default" : "outline"}
        >
          {isFollowing ? (
            <>
              <UserCheck className="w-4 h-4 mr-2" />
              {t('profile.following')}
            </>
          ) : (
            <>
              <UserPlus className="w-4 h-4 mr-2" />
              {t('profile.follow')}
            </>
          )}
        </Button>
      )}
    </div>
  );
};

export default PrivateProfileView;